module.exports = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBzdGFuZGFsb25lPSJubyI/PjwhRE9DVFlQRSBzdmcgUFVCTElDICItLy9XM0MvL0RURCBTVkcgMS4xLy9FTiIgImh0dHA6Ly93d3cudzMub3JnL0dyYXBoaWNzL1NWRy8xLjEvRFREL3N2ZzExLmR0ZCI+PHN2ZyBjbGFzcz0iaWNvbiIgdmlld0JveD0iMCAwIDEwMjQgMTAyNCIgdmVyc2lvbj0iMS4xIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPjxwYXRoIGZpbGw9IiMzMzMzMzMiIGQ9Ik01MDAuOCA2MDQuNzc5TDI2Ny4zMDcgMzcxLjM5MmwtNDUuMjI3IDQ1LjI3IDI3OC43NDEgMjc4LjYxM0w3NzkuMzA3IDQxNi42NmwtNDUuMjQ4LTQ1LjI0OHoiIC8+PC9zdmc+Cg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/detail/arrow-down.svg
// module id = orp/
// module chunks = 0 1